<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>{{ titleAction }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn dark icon @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-xl>
            <v-layout wrap>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-flex d-flex lg6 md6 sm12 xs12>
                  <v-switch
                    v-model="localCurso.active"
                    :disabled="!Edit"
                    :label="$t('fields.global.active')"
                    color="primary"
                  />
                </v-flex>
              </v-flex>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-tabs
                  ref="tablanguage"
                  v-model="tabs"
                  color="primary"
                  fixed-tabs
                >
                  <v-tab
                    v-for="(lang, index) in localCurso.curso"
                    :key="index + 100"
                  >
                    {{ lang.name }}
                  </v-tab>
                  <v-tab-item
                    v-for="(lang, index) in localCurso.curso"
                    :key="index + 200"
                  >
                    <v-container fluid grid-list-xl>
                      <v-layout wrap>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                          <IgTextField
                            v-if="lang.iso === '5bd9f3ee7fa5610014fed21e'"
                            v-model="localCurso.name[index].text"
                            :disabled="!Edit"
                            :rules="[(v) => rules.vacio(v, 'name')]"
                            :status="dialog"
                            :label="$t('fields.global.name')"
                          />
                          <IgTextField
                            v-else
                            v-model="localCurso.name[index].text"
                            :disabled="!Edit"
                            :status="dialog"
                            :label="$t('fields.global.name')"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                          <editor
                            v-model="localCurso.curso[index].text"
                            api-key="qa7ul987udjksrwwu3j7h3k0036fxgr7zudae3762538h2yd"
                            :init="editorInit"
                          />
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
              <v-flex d-flex lg12 md12 sm12 xs12>
                <v-flex d-flex lg4 md4 sm12 xs12>
                  <v-autocomplete
                    v-model="localCurso.teams"
                    :disabled="!Edit"
                    :items="teamsList"
                    :rules="[(v) => rules.vacio(v, 'team')]"
                    :label="
                      $t('action.actions.select', { field: $tc('models.team') })
                    "
                    persistent-hint
                    multiple
                    :chips="true"
                    :deletable-chips="true"
                    prepend-icon="mdi-city"
                  >
                    <v-list-tile
                      slot="prepend-item"
                      ripple
                      @click="toggleTeams"
                    >
                      <v-list-tile-action>
                        <v-icon
                          :color="
                            localCurso.teams.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ iconTeams }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile>
                    <v-divider slot="prepend-item" class="mt-2" />
                  </v-autocomplete>
                </v-flex>
                <v-flex d-flex lg4 md4 sm12 xs12>
                  <v-autocomplete
                    v-model="localCurso.users"
                    :disabled="!Edit"
                    :items="usersList"
                    :rules="[(v) => rules.vacio(v, 'user')]"
                    :label="
                      $t('action.actions.select', { field: $tc('models.user') })
                    "
                    persistent-hint
                    multiple
                    :chips="true"
                    :deletable-chips="true"
                    prepend-icon="mdi-city"
                  >
                    <v-list-tile
                      slot="prepend-item"
                      ripple
                      @click="toggleUsers"
                    >
                      <v-list-tile-action>
                        <v-icon
                          :color="
                            localCurso.users.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ iconUsers }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile>
                    <v-divider slot="prepend-item" class="mt-2" />
                  </v-autocomplete>
                </v-flex>
                <v-flex d-flex lg4 md4 sm12 xs12>
                  <v-autocomplete
                    v-model="localCurso.tournaments"
                    :disabled="!Edit"
                    :items="tournamentsList"
                    :rules="[(v) => rules.vacio(v, 'tournament')]"
                    :label="
                      $t('action.actions.select', {
                        field: $tc('models.tournament'),
                      })
                    "
                    persistent-hint
                    multiple
                    :chips="true"
                    :deletable-chips="true"
                    prepend-icon="mdi-city"
                  >
                    <v-list-tile
                      slot="prepend-item"
                      ripple
                      @click="toggleTournaments"
                    >
                      <v-list-tile-action>
                        <v-icon
                          :color="
                            localCurso.tournaments.length > 0
                              ? 'indigo darken-4'
                              : ''
                          "
                        >
                          {{ iconTournaments }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile>
                    <v-divider slot="prepend-item" class="mt-2" />
                  </v-autocomplete>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn v-if="Edit" color="warning" small @click="reset()">
            {{ $t('action.buttons.reset') }}
          </v-btn>
          <v-btn
            v-if="externalAction === 'create'"
            color="success"
            small
            @click="courseCreate()"
          >
            {{ $t('action.buttons.create') }}
          </v-btn>
          <v-btn
            v-if="externalAction === 'update'"
            color="secondary"
            small
            @click="courseUpdate()"
          >
            {{ $t('action.buttons.update') }}
          </v-btn>
          <v-btn
            v-if="externalAction === 'delete'"
            color="error"
            small
            @click="courseRemove()"
          >
            {{ $t('action.buttons.delete') }}
          </v-btn>
          <v-btn color="primary" small @click="cancel()">
            {{ $t('action.buttons.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import queueToast from '@/helpers/queueToast'
import rules from '@/helpers/rules'

export default {
  name: 'FormManager',
  components: {
    Editor,
  },
  mixins: [rules],
  props: {
    modal: {
      type: Boolean,
      required: false,
      default: false,
    },
    externalAction: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      raro: false,
      editorInit: {
        plugins: 'wordcount image imagetools media autoresize',
        toolbar:
          'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | image media',
        automatic_uploads: false,
        min_height: 300,
        resize: true,
        media_live_embeds: true,
        file_picker_types: 'media',
        video_template_callback: function (data) {
          return (
            '<video width="' +
            data.width +
            '" height="' +
            data.height +
            '"' +
            (data.poster ? ' poster="' + data.poster + '"' : '') +
            ' controls="controls">\n' +
            '<source src="' +
            data.source1 +
            '"' +
            (data.source1mime ? ' type="' + data.source1mime + '"' : '') +
            ' />\n' +
            (data.source2
              ? '<source src="' +
                data.source2 +
                '"' +
                (data.source2mime ? ' type="' + data.source2mime + '"' : '') +
                ' />\n'
              : '') +
            '</video>'
          )
        },
        imagetools_toolbar:
          'rotateleft rotateright | flipv fliph | editimage imageoptions',
        images_upload_handler: function (blobInfo, success, failure) {
          function getToken() {
            let result = localStorage.getItem('userToken')
            return result ? result.trim() : ''
          }
          let xhr, formData

          xhr = new XMLHttpRequest()
          xhr.withCredentials = false
          xhr.open('POST', process.env.VUE_APP_API_URL + 'upload/file')
          xhr.setRequestHeader('Authorization', 'Bearer ' + getToken())

          xhr.onload = function () {
            let json

            if (xhr.status !== 200) {
              failure('HTTP Error: ' + xhr.status)
              return
            }

            json = JSON.parse(xhr.responseText)

            if (
              !json ||
              !json.data ||
              !json.data.file ||
              typeof json.data.file.path !== 'string'
            ) {
              failure('Invalid JSON: ' + xhr.responseText)
              return
            }
            console.log(json)

            success(process.env.VUE_APP_IMAGE_URL + json.data.file.filename)
          }

          formData = new FormData()
          formData.append('file', blobInfo.blob(), blobInfo.filename())
          xhr.send(formData)
        },
        file_picker_callback: function (cb, value, meta) {
          if (meta.filetype === 'media') {
            // eslint-disable-next-line no-inner-declarations
            function getToken() {
              let result = localStorage.getItem('userToken')
              return result ? result.trim() : ''
            }
            let input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'video/*')
            input.onchange = function () {
              const file = this.files[0]
              let reader = new FileReader()
              reader.readAsDataURL(file)
              reader.onload = function () {
                const id = 'blobid' + new Date().getTime()
                // eslint-disable-next-line no-undef
                const blobCache = tinymce.activeEditor.editorUpload.blobCache
                const base64 = reader.result.split(',')[1]
                const blobInfo = blobCache.create(id, file, base64)
                blobCache.add(blobInfo)
                let xhr, formData
                xhr = new XMLHttpRequest()
                xhr.withCredentials = false
                xhr.open('POST', process.env.VUE_APP_API_URL + 'upload/file')
                xhr.setRequestHeader('Authorization', 'Bearer ' + getToken())
                xhr.onload = function () {
                  let json
                  if (xhr.status !== 200) {
                    console.log('HTTP Error: ' + xhr.status)
                    return
                  }
                  json = JSON.parse(xhr.responseText)
                  if (
                    !json ||
                    !json.data ||
                    !json.data.file ||
                    typeof json.data.file.path !== 'string'
                  ) {
                    console.log('Invalid JSON: ' + xhr.responseText)
                    return
                  }
                  console.log(json)
                  // eslint-disable-next-line standard/no-callback-literal
                  cb(process.env.VUE_APP_IMAGE_URL + json.data.file.filename, {
                    title: json.data.file.filename,
                  })
                }
                formData = new FormData()
                formData.append('file', blobInfo.blob(), blobInfo.filename())
                xhr.send(formData)
              }
            }
            input.click()
          }
        },
      },
      localCurso: {
        name: [],
        curso: [],
        tournaments: [],
        teams: [],
        users: [],
        active: false,
      },
      tabs: 0,
    }
  },
  watch: {
    externalAction: function () {
      this.editorInit.language = this.$i18n.locale
      this.resolveAction()
    },
    courseSelected: function () {
      this.resolveAction()
    },
  },
  created() {
    this.editorInit.language_url = 'https://infogon.me/tiny-langs/todos.js'
    this.editorInit.language = this.$i18n.locale
  },
  mounted() {
    this.localCurso.name = this.fieldLanguage()
    this.localCurso.curso = this.fieldLanguage()
  },
  computed: {
    ...mapState({
      languagesList: (state) => state.languages.listLanguages,
      teamsList: (state) => state.teams.listSelectTeams,
      usersList: (state) => state.users.listSelectUsers,
      courseSelected: (state) => state.courses.selected,
      courseFile: (state) => state.courses.file,
    }),
    ...mapGetters({
      tournamentsList: 'tournaments/selectList',
    }),
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
    titleAction() {
      return 'Cursos'
    },
    /**
     * @return {boolean}
     */
    Edit() {
      return this.externalAction !== 'delete'
    },
    likesAllTeams() {
      return this.localCurso.teams.length === this.teamsList.length
    },
    likesSomeTeams() {
      return this.localCurso.teams.length > 0 && !this.likesAllTeams
    },
    iconTeams() {
      if (this.likesAllTeams) return 'check_circle_outline'
      if (this.likesSomeTeams) return 'remove_circle_outline'
      return 'clear_circle_outline'
    },
    likesAllUsers() {
      return this.localCurso.users.length === this.usersList.length
    },
    likesSomeUsers() {
      return this.localCurso.users.length > 0 && !this.likesAllUsers
    },
    iconUsers() {
      if (this.likesAllUsers) return 'check_circle_outline'
      if (this.likesSomeUsers) return 'remove_circle_outline'
      return 'clear_circle_outline'
    },
    likesAllTournaments() {
      return this.localCurso.tournaments.length === this.tournamentsList.length
    },
    likesSomeTournaments() {
      return this.localCurso.tournaments.length > 0 && !this.likesAllTournaments
    },
    iconTournaments() {
      if (this.likesAllTournaments) return 'check_circle_outline'
      if (this.likesSomeTournaments) return 'remove_circle_outline'
      return 'clear_circle_outline'
    },
  },
  methods: {
    ...mapActions({
      create: 'courses/setNew',
      update: 'courses/setUpdate',
      remove: 'courses/setEliminate',
    }),
    fieldLanguage(fieldBase = null) {
      let result = []
      if (!fieldBase) {
        this.languagesList.forEach((item) => {
          result.push({
            text: '',
            iso: item._id,
            name: item.name,
          })
        })
      } else {
        this.languagesList.forEach((item) => {
          let search = fieldBase.find((element) => element.iso === item._id)
          if (!search) {
            search = item
          }
          result.push({
            text: search.text || '',
            iso: item._id,
            name: item.name,
          })
        })
      }
      return result
    },
    resolveAction() {
      this.tabs = 0
      if (this.externalAction === 'create') {
        this.localCurso = {
          name: this.fieldLanguage(),
          curso: this.fieldLanguage(),
          tournaments: [],
          teams: [],
          users: [],
          active: false,
        }
      }
      if (
        this.externalAction === 'update' ||
        this.externalAction === 'delete'
      ) {
        if (this.courseSelected) {
          this.localCurso = {
            name: this.fieldLanguage(this.courseSelected.name),
            curso: this.fieldLanguage(this.courseSelected.content),
            tournaments: this.courseSelected.tournaments
              ? Array.from(this.courseSelected.tournaments)
              : [],
            teams: this.courseSelected.teams
              ? Array.from(this.courseSelected.teams)
              : [],
            users: this.courseSelected.users
              ? Array.from(this.courseSelected.users)
              : [],
            active: this.courseSelected.active || false,
          }
        } else {
          this.localCurso = {
            name: this.fieldLanguage(),
            curso: this.fieldLanguage(),
            tournaments: [],
            teams: [],
            users: [],
            active: false,
          }
        }
      }
    },
    validateCourse() {
      let message = []
      let error = false
      let spanishName = this.localCurso.name.find(
        (item) => item.iso === 'es-ES'
      )
      if (!spanishName || spanishName.text === '') {
        error = true
        message.push(this.$t('error.error.nameSpanish'))
      }
      let spanishText = this.localCurso.curso.find(
        (item) => item.iso === 'es-ES'
      )
      if (!spanishText || spanishText.text === '') {
        error = true
        message.push(this.$t('error.error.contentSpanish'))
      }
      return {
        message,
        error,
      }
    },
    createCourse() {
      let sendCourse = {}
      sendCourse.active = this.localCurso.active
      sendCourse.users = Array.from(this.localCurso.users)
      sendCourse.teams = Array.from(this.localCurso.teams)
      sendCourse.tournaments = Array.from(this.localCurso.tournaments)
      sendCourse.content = []
      sendCourse.name = []
      this.localCurso.curso.forEach((item) => {
        if (item.text) {
          sendCourse.content.push(Object.assign({}, item))
        }
      })
      this.localCurso.name.forEach((item) => {
        if (item.text) {
          sendCourse.name.push(Object.assign({}, item))
        }
      })
      console.log(sendCourse)
      return sendCourse
    },
    courseCreate() {
      let error = this.validateCourse()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let result = this.createCourse()
      this.create(result)
      this.cancel()
    },
    courseUpdate() {
      let error = this.validateCourse()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let result = this.createCourse()
      result._id = this.courseSelected._id
      this.update(result)
      this.cancel()
    },
    courseRemove() {
      this.remove(this.courseSelected._id)
      this.cancel()
    },
    reset() {
      this.localCurso = {
        name: this.fieldLanguage(),
        curso: this.fieldLanguage(),
        tournaments: [],
        teams: [],
        users: [],
        active: false,
      }
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    toggleTeams() {
      this.$nextTick(() => {
        if (this.likesAllTeams) {
          this.localCurso.teams = []
        } else {
          this.localCurso.teams = this.teamsList.slice()
        }
      })
    },
    toggleTournaments() {
      this.$nextTick(() => {
        if (this.likesAllTournaments) {
          this.localCurso.tournaments = []
        } else {
          this.localCurso.tournaments = this.tournamentsList.slice()
        }
      })
    },
    toggleUsers() {
      this.$nextTick(() => {
        if (this.likesAllUsers) {
          this.localCurso.users = []
        } else {
          this.localCurso.users = this.usersList.slice()
        }
      })
    },
  },
}
</script>
